/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Dropdown1} from '../../../../_metronic/partials'
import {useLocation} from 'react-router'
import {useEffect, useState} from 'react'
import {Create} from '../components/Create'
import {Step2} from '../components/Step2'
import {Step3} from '../components/Step3'
import axios from 'axios'
import '../../index.css'
export function CreateBanner() {
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const [user, setUser] = useState<any>([])
  const [step, setStep] = useState<Number>(1)
  useEffect(
    () => {
      console.log(location)
      setUser(location.state)
    },
    [] // Only re-call effect if value or delay changes
  )
  const getStep = (stepCheck: Number) => {
    let x = ''
    if (step === stepCheck) x = 'active'
    return x
  }

  const nextStep = (stepCheck: Number) => {
    setStep(Number(stepCheck)+1)
  }

  const goBack = (stepCheck: Number) => {
    setStep(Number(stepCheck)-1)
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <h1>Create Banner</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Create/>
      
    </div>
  )
}
